import { CaseModel, StateTransitionData, StateTypes, ViewType } from "@ortho-next/nextray-core";
import { Context } from "./Context";
import { Actions, State, WorkflowRunning } from "./State";

/**
 * State indicating that user can execute Reverse Planning Method.
 */
export class RPM extends State {
	public stateDescription = {
		isWorkflowRunning: WorkflowRunning.none,
		isPointsPositioningRunning: false
	};

	constructor(context: Context, caseModel: CaseModel, restore?: object) {
		super(context, caseModel, StateTypes.RPM, restore);
	}

	public initState(): void {
		if (this._restore) {
			if (this._caseModel.imgAP) {
				this.dispatchToMain("setView", ViewType.AP);
			} else {
				this.dispatchToMain("setView", ViewType.LT);
			}
		}
	}

	protected handleChangeStateEvent<K extends keyof Actions>(event: K, args: Actions[K]): StateTransitionData {
		switch (event) {
			case "switchToCalibrated":
				this.dispatchToMain(event, args);
				return { type: StateTypes.calibrated, data: { caseModel: this._caseModel } };
			case "switchToDeformity":
				this.dispatchToMain(event, args);
				return { type: StateTypes.deformityAnalysis, data: { caseModel: this._caseModel } };
		}
		
		return super.handleNotChangeStateEvent(event, args);
	}
}
